module.exports = __webpack_public_path__ + "static/media/recurring_uncovered.dababc06.svg";